export const segments = {
  orders: 'orders',
};

export const routeParams = {
  operationId: 'operationId',
};

export const routes = {
  orders: (operationId: string | number) => {
    return `/${segments.orders}/${operationId}`;
  },
  edit: (operationId: string | number) => {
    return `/operations/${operationId}/edit`;
  },
};
